import React from 'react';
import cn from 'classnames';
import { getTranslations } from '@translations';
import styles from './styles/index.module.scss';

/**
 * This components concerns showing the suggestions, trends and history after the
 * interaction from user. Please note that this section is taken from manomano-sf.
 */

const SearchContent = () => {
  const translations = getTranslations();

  return (
    <div className="searchbar-results__overflow" id="results-overflow">
      <div
        className={cn(
          'searchbar-results__block',
          styles.searchContentResultContainer,
        )}
        id="suggestions-block"
        data-keyboard="false"
      >
        <div className="searchbar-results__title">
          {translations('header.subheader.search.content.suggestions')}
        </div>
        <div className="searchbar-results__content" id="suggestion-content" />
      </div>

      <div
        className={cn(
          'searchbar-results__block',
          styles.searchContentResultContainer,
        )}
        id="query-suggestions-block"
        data-keyboard="false"
      >
        <div className="searchbar-results__title">
          {translations('header.subheader.search.content.suggestions')}
        </div>
        <div
          className="searchbar-results__content"
          id="query-suggestions-content"
        />
      </div>

      <div
        className={cn(
          'searchbar-results__block',
          styles.searchContentResultContainer,
        )}
        id="category-block"
        data-keyboard="false"
      >
        <div className="searchbar-results__title">
          {translations(
            'header.subheader.search.content.autocomplete.categories',
          )}
        </div>
        <div className="searchbar-results__content" id="category-content" />
      </div>

      <div
        className={cn(
          'searchbar-results__block',
          styles.searchContentResultContainer,
        )}
        id="brand-block"
        data-keyboard="false"
      >
        <div className="searchbar-results__title">
          {translations('header.subheader.search.content.autocomplete.brand')}
        </div>
        <div className="searchbar-results__content" id="brand-content" />
      </div>

      <div
        className={cn(
          'searchbar-results__block',
          styles.searchContentResultContainer,
        )}
        id="tipsheet-block"
        data-keyboard="false"
      >
        <div className="searchbar-results__title">
          {translations(
            'header.subheader.search.content.autocomplete.tipsheet',
          )}
        </div>
        <div className="searchbar-results__content" id="tipsheet-content" />
      </div>

      <div
        className={cn(
          'searchbar-results__block',
          styles.searchContentResultContainer,
        )}
        id="history-block"
        data-keyboard="false"
      >
        <div className="searchbar-results__title">
          {translations(
            'header.subheader.search.content.results.history.title',
          )}
        </div>
        <div className="searchbar-results__content" id="history-content" />
        <span className="searchbar-results__clear-history" id="clear-history">
          {translations(
            'header.subheader.search.content.results.clear.history',
          )}
        </span>
      </div>
    </div>
  );
};

export default SearchContent;
